import { defineComponent, computed } from 'vue';
import useQuasar from 'quasar/src/composables/use-quasar/use-quasar.js';
import { sanitizeHtml } from 'src/apps/cloud/utils/validation';
export default defineComponent({
    name: 'DialogComponent',
    setup() {
        const $q = useQuasar();
        const sanitizedContent = computed(() => {
            const content = $q.store.dialog.text || $q.store.dialog.html || '';
            return sanitizeHtml(content);
        });
        return {
            sanitizedContent
        };
    }
});
